import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    SubTitle,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/kebiki`;

interface Props {
    className?: string;
}

export const KebikiInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            毛引きの選び方
        </Title>
        <Image src={`${IMG_PATH}/kebiki.png`} />

        <Paragraph>
            ※表示している糸・和紙の色は、製品となったときに多少明るく見えたり、
            ご覧いただいている画面の環境によって色の見え方が多少異なりますので、ご了承ください。
        </Paragraph>

        <SubTitle>毛引きとは</SubTitle>
        <Paragraph>
            毛引き・口漆・口引き・口取り等と呼ばれます。矧糸の縁に引かれ、矢の仕上がりを高めます。
        </Paragraph>

        <SubTitle>選び方</SubTitle>
        <Paragraph>
            色により、優雅にも可憐にも伝統的にもポップにもなります。
            素敵な色の組合せをお楽しみ下さい。
            ご指定が無い場合は人気の高い金で仕上げさせていただきます。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpKebiki: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <KebikiInner />
            </div>
        </div>
    </Panel>
);
